module.exports = __webpack_public_path__ + "img/icon-google.cab9c3d7.png";